// Tabla comparativa de configuración: matriz equipo x campo contra el golden.
//
// Vive en su propio archivo (tipos incluidos) a propósito: `useConfig.ts` y
// `api/types.ts` los está tocando otro frente en paralelo, y así no chocamos.
import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";

/** Tres estados, y los dos últimos NO son lo mismo. */
export type EstadoCelda = "ok" | "deriva" | "sin_datos";

export interface CeldaComparativa {
  estado: EstadoCelda;
  /** El valor real del equipo. `null` cuando no se pudo leer. */
  valor: string | number | boolean | null;
}

export interface CampoComparativa {
  key: string;
  label: string;
  /**
   * `golden`    se compara contra el valor único de la flota.
   * `presencia` varía por sitio a propósito; sólo se comprueba que haya dato.
   */
  tipo: "golden" | "presencia";
  esperado: string | number | boolean | null;
}

export interface EquipoComparativa {
  device_id: string;
  sitio: string;
  ip: string;
  estado: EstadoCelda;
  campos_en_deriva: number;
  capturado_en: string | null;
  /** Por qué no se pudo cosechar. Sólo viene cuando `estado` es `sin_datos`. */
  motivo: string | null;
  celdas: Record<string, CeldaComparativa>;
  /** Contexto operativo del sitio: concentrador, vía de reinicio, operador… */
  inventario: Record<string, string | null>;
}

export interface Comparativa {
  campos: CampoComparativa[];
  inventario_campos: { key: string; label: string }[];
  equipos: EquipoComparativa[];
  resumen: { conformes: number; con_deriva: number; sin_datos: number; total: number };
  generated_at: string;
}

export function useComparativa(scope = "holanda") {
  return useQuery({
    queryKey: ["config-comparativa", scope],
    queryFn: ({ signal }) =>
      api<Comparativa>(`/api/v1/config/comparativa?scope=${encodeURIComponent(scope)}`, {
        signal,
      }),
    refetchInterval: 60_000,
    placeholderData: (prev) => prev,
  });
}
